import { render, staticRenderFns } from "./codeDictList.vue?vue&type=template&id=883b4f96&scoped=true"
import script from "./codeDictList.vue?vue&type=script&lang=js"
export * from "./codeDictList.vue?vue&type=script&lang=js"
import style0 from "./codeDictList.vue?vue&type=style&index=0&id=883b4f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "883b4f96",
  null
  
)

export default component.exports